import styled from "styled-components";

export const BoldFXRate = styled.div`
    font-size: 14px;
    font-weight: 600;
`
